import React, { useState, useEffect } from 'react';
import axios from './lib/axiosClient';

function Packages() {
  var [packages, setPackages] = useState([]);
  var [purchases, setPurchases] = useState([]);
  var [services, setServices] = useState([]);
  var [customers, setCustomers] = useState([]);
  var [showForm, setShowForm] = useState(false);
  var [showSell, setShowSell] = useState(null);
  var [loading, setLoading] = useState(true);
  var [form, setForm] = useState({ name: '', description: '', service_id: '', visit_count: 5, price: '', expires_days: '' });

  useEffect(function() { loadAll(); }, []);

  var loadAll = async function() {
    try {
      var [pkgRes, purRes, svcRes, custRes] = await Promise.all([
        axios.get('/api/packages'),
        axios.get('/api/packages/purchases?active_only=true'),
        axios.get('/api/services?active_only=true'),
        axios.get('/api/customers'),
      ]);
      setPackages(pkgRes.data.packages || []);
      setPurchases(purRes.data.purchases || []);
      setServices(svcRes.data.services || []);
      setCustomers(custRes.data.customers || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  var handleSave = async function() {
    try {
      await axios.post('/api/packages', form);
      setShowForm(false);
      setForm({ name: '', description: '', service_id: '', visit_count: 5, price: '', expires_days: '' });
      loadAll();
    } catch (e) { alert('Error saving package'); }
  };

  var handleSell = async function(packageId, contactId, method) {
    try {
      await axios.post('/api/packages/purchases', { package_id: packageId, contact_id: contactId, payment_method: method });
      setShowSell(null);
      loadAll();
      alert('✅ Package sold!');
    } catch (e) { alert('Error selling package'); }
  };

  var handleRedeem = async function(purchaseId) {
    try {
      var res = await axios.post('/api/packages/purchases/' + purchaseId + '/redeem');
      alert('✅ ' + res.data.message);
      loadAll();
    } catch (e) { alert(e.response?.data?.error || 'Error redeeming'); }
  };

  var handleDelete = async function(id) {
    if (!window.confirm('Deactivate this package?')) return;
    await axios.delete('/api/packages/' + id);
    loadAll();
  };

  if (loading) return <div style={S.loading}>Loading packages...</div>;

  return (
    <div style={{ maxWidth: '100%' }}>
      <div style={S.header}>
        <div>
          <h1 style={S.title}>🎟️ Packages & Bundles</h1>
          <p style={S.subtitle}>Sell prepaid visit packages to lock in recurring revenue</p>
        </div>
        <button onClick={function() { setShowForm(true); }} style={S.addBtn}>+ Create Package</button>
      </div>

      {/* Active Packages */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16, marginBottom: 32 }}>
        {packages.filter(function(p) { return p.is_active; }).map(function(p) {
          var singlePrice = p.services?.price || 0;
          var savings = (singlePrice * p.visit_count) - p.price;
          return (
            <div key={p.id} style={S.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={S.cardTitle}>{p.name}</div>
                  <div style={S.cardDesc}>{p.description || p.services?.name || 'Any service'}</div>
                </div>
                <button onClick={function() { handleDelete(p.id); }} style={S.deleteBtn}>×</button>
              </div>
              <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                <div style={S.stat}>
                  <div style={S.statValue}>{p.visit_count}</div>
                  <div style={S.statLabel}>visits</div>
                </div>
                <div style={S.stat}>
                  <div style={{ ...S.statValue, color: '#10b981' }}>${parseFloat(p.price).toFixed(0)}</div>
                  <div style={S.statLabel}>price</div>
                </div>
                {savings > 0 && (
                  <div style={S.stat}>
                    <div style={{ ...S.statValue, color: '#ffab40' }}>${savings.toFixed(0)}</div>
                    <div style={S.statLabel}>savings</div>
                  </div>
                )}
              </div>
              {p.expires_days && <div style={{ color: '#888', fontSize: 12, marginTop: 8 }}>Expires {p.expires_days} days after purchase</div>}
              <button onClick={function() { setShowSell(p); }} style={S.sellBtn}>💰 Sell to Customer</button>
            </div>
          );
        })}
        {packages.filter(function(p) { return p.is_active; }).length === 0 && (
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: 40, color: '#888' }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🎟️</div>
            <div>No packages yet. Create one to start selling!</div>
          </div>
        )}
      </div>

      {/* Active Purchases */}
      {purchases.length > 0 && (
        <div>
          <h2 style={{ color: '#fff', fontSize: 18, fontWeight: 700, marginBottom: 16 }}>📋 Active Customer Packages</h2>
          <div style={{ display: 'grid', gap: 8 }}>
            {purchases.map(function(p) {
              var pct = p.packages?.visit_count ? ((p.visits_used || 0) / p.packages.visit_count) * 100 : 0;
              var isExpired = p.expires_at && new Date(p.expires_at) < new Date();
              return (
                <div key={p.id} style={{ ...S.row, opacity: isExpired ? 0.5 : 1 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ color: '#fff', fontWeight: 600 }}>
                      {p.contacts?.first_name} {p.contacts?.last_name}
                      <span style={{ color: '#888', fontWeight: 400, marginLeft: 8, fontSize: 13 }}>{p.packages?.name}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 8 }}>
                      <div style={{ flex: 1, height: 8, background: '#1a1a30', borderRadius: 4, overflow: 'hidden' }}>
                        <div style={{ width: pct + '%', height: '100%', background: 'linear-gradient(90deg, #ff6b2b, #ffab40)', borderRadius: 4, transition: 'width 0.5s' }} />
                      </div>
                      <span style={{ color: '#888', fontSize: 12, whiteSpace: 'nowrap' }}>{p.visits_used || 0}/{p.packages?.visit_count} used</span>
                    </div>
                    {isExpired && <div style={{ color: '#ef4444', fontSize: 11, marginTop: 4 }}>⚠️ Expired</div>}
                  </div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span style={{ color: '#10b981', fontWeight: 700, fontSize: 18 }}>{p.visits_remaining}</span>
                    <span style={{ color: '#888', fontSize: 12 }}>left</span>
                    {p.visits_remaining > 0 && !isExpired && (
                      <button onClick={function() { handleRedeem(p.id); }} style={S.redeemBtn}>✓ Redeem</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Create Package Modal */}
      {showForm && (
        <div style={S.overlay} onClick={function() { setShowForm(false); }}>
          <div style={S.modal} onClick={function(e) { e.stopPropagation(); }}>
            <h2 style={{ color: '#fff', margin: '0 0 20px' }}>Create Package</h2>
            <div style={S.field}>
              <label style={S.label}>Package Name</label>
              <input style={S.input} value={form.name} onChange={function(e) { setForm({ ...form, name: e.target.value }); }} placeholder="e.g. 5-Visit Facial Bundle" />
            </div>
            <div style={S.field}>
              <label style={S.label}>Description (optional)</label>
              <input style={S.input} value={form.description} onChange={function(e) { setForm({ ...form, description: e.target.value }); }} placeholder="Buy 5, save 20%" />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div style={S.field}>
                <label style={S.label}>Service</label>
                <select style={S.input} value={form.service_id} onChange={function(e) { setForm({ ...form, service_id: e.target.value }); }}>
                  <option value="">Any service</option>
                  {services.map(function(s) { return <option key={s.id} value={s.id}>{s.name} (${s.price})</option>; })}
                </select>
              </div>
              <div style={S.field}>
                <label style={S.label}># of Visits</label>
                <input style={S.input} type="number" min="2" value={form.visit_count} onChange={function(e) { setForm({ ...form, visit_count: parseInt(e.target.value) }); }} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div style={S.field}>
                <label style={S.label}>Package Price ($)</label>
                <input style={S.input} type="number" step="0.01" value={form.price} onChange={function(e) { setForm({ ...form, price: e.target.value }); }} placeholder="e.g. 200" />
              </div>
              <div style={S.field}>
                <label style={S.label}>Expires (days, optional)</label>
                <input style={S.input} type="number" value={form.expires_days} onChange={function(e) { setForm({ ...form, expires_days: e.target.value }); }} placeholder="e.g. 365" />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <button onClick={function() { setShowForm(false); }} style={S.cancelBtn}>Cancel</button>
              <button onClick={handleSave} style={S.saveBtn}>Create Package</button>
            </div>
          </div>
        </div>
      )}

      {/* Sell Package Modal */}
      {showSell && (
        <div style={S.overlay} onClick={function() { setShowSell(null); }}>
          <div style={S.modal} onClick={function(e) { e.stopPropagation(); }}>
            <h2 style={{ color: '#fff', margin: '0 0 8px' }}>Sell: {showSell.name}</h2>
            <p style={{ color: '#888', margin: '0 0 20px', fontSize: 14 }}>{showSell.visit_count} visits for ${parseFloat(showSell.price).toFixed(2)}</p>
            <SellForm customers={customers} pkg={showSell} onSell={handleSell} onCancel={function() { setShowSell(null); }} />
          </div>
        </div>
      )}
    </div>
  );
}

function SellForm({ customers, pkg, onSell, onCancel }) {
  var [contactId, setContactId] = useState('');
  var [method, setMethod] = useState('card');
  var [search, setSearch] = useState('');
  var filtered = customers.filter(function(c) {
    var q = search.toLowerCase();
    return (c.first_name + ' ' + c.last_name + ' ' + (c.phone || '')).toLowerCase().includes(q);
  }).slice(0, 8);

  return (
    <div>
      <div style={S.field}>
        <label style={S.label}>Customer</label>
        <input style={S.input} value={search} onChange={function(e) { setSearch(e.target.value); setContactId(''); }} placeholder="Search by name or phone..." />
        {search && !contactId && (
          <div style={{ maxHeight: 160, overflowY: 'auto', marginTop: 4 }}>
            {filtered.map(function(c) {
              return (
                <div key={c.id} onClick={function() { setContactId(c.id); setSearch(c.first_name + ' ' + c.last_name); }}
                  style={{ padding: '8px 12px', cursor: 'pointer', color: '#fff', fontSize: 14, borderBottom: '1px solid #1e1e35' }}>
                  {c.first_name} {c.last_name} <span style={{ color: '#888' }}>{c.phone}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div style={S.field}>
        <label style={S.label}>Payment Method</label>
        <select style={S.input} value={method} onChange={function(e) { setMethod(e.target.value); }}>
          <option value="card">Card</option>
          <option value="cash">Cash</option>
          <option value="other">Other</option>
        </select>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
        <button onClick={onCancel} style={S.cancelBtn}>Cancel</button>
        <button onClick={function() { if (!contactId) { alert('Select a customer'); return; } onSell(pkg.id, contactId, method); }}
          style={S.saveBtn}>Sell Package — ${parseFloat(pkg.price).toFixed(2)}</button>
      </div>
    </div>
  );
}

var S = {
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', color: '#888', fontSize: 18 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28, flexWrap: 'wrap', gap: 12 },
  title: { fontSize: 26, fontWeight: 800, color: '#fff', margin: '0 0 6px' },
  subtitle: { fontSize: 14, color: '#888', margin: 0 },
  addBtn: { padding: '12px 24px', background: 'linear-gradient(135deg, #ff6b2b, #ffab40)', border: 'none', borderRadius: 12, color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
  card: { background: '#12121f', borderRadius: 16, padding: 24, border: '1px solid #1e1e35' },
  cardTitle: { color: '#fff', fontSize: 18, fontWeight: 700 },
  cardDesc: { color: '#888', fontSize: 13, marginTop: 4 },
  stat: { textAlign: 'center' },
  statValue: { color: '#fff', fontSize: 22, fontWeight: 800 },
  statLabel: { color: '#888', fontSize: 11, marginTop: 2 },
  sellBtn: { width: '100%', marginTop: 16, padding: '10px', background: '#10b981', border: 'none', borderRadius: 8, color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  deleteBtn: { background: 'none', border: 'none', color: '#666', fontSize: 20, cursor: 'pointer', padding: '0 4px' },
  redeemBtn: { padding: '6px 14px', background: '#ff6b2b', border: 'none', borderRadius: 6, color: '#fff', fontWeight: 700, fontSize: 12, cursor: 'pointer' },
  row: { display: 'flex', alignItems: 'center', gap: 16, background: '#12121f', borderRadius: 12, padding: '14px 18px', border: '1px solid #1e1e35' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999, padding: 20 },
  modal: { background: '#12121f', borderRadius: 16, padding: 28, maxWidth: 480, width: '100%', border: '1px solid #1e1e35', maxHeight: '90vh', overflowY: 'auto' },
  field: { marginBottom: 14 },
  label: { display: 'block', color: '#aaa', fontSize: 12, fontWeight: 600, marginBottom: 6 },
  input: { width: '100%', padding: '10px 14px', background: '#252840', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  cancelBtn: { flex: 1, padding: 12, background: '#334155', border: 'none', borderRadius: 8, color: '#fff', fontWeight: 600, cursor: 'pointer' },
  saveBtn: { flex: 1, padding: 12, background: 'linear-gradient(135deg, #ff6b2b, #ffab40)', border: 'none', borderRadius: 8, color: '#fff', fontWeight: 700, cursor: 'pointer' },
};

export default Packages;
